import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { IMG } from "../data/content";

export default function Discovery() {
  return (
    <section data-testid="discovery-section" className="mx-auto max-w-7xl px-6 py-24 sm:px-12 sm:py-32 lg:px-20 lg:py-40">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">The Discovery</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              <Link data-testid="discovery-story-link" to="/story" className="text-inherit no-underline">
                Some places are visited.
                <br />
                <span className="italic text-brass">Some places are discovered.</span>
              </Link>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-ivory/75 sm:text-lg">
              The road to The Jamoon ends at a small village called Bhasedi. From there, the
              last 3.5 kilometres are walked — through dense sal forest, in the company of
              those who know it — until the trees open onto the Ramganga.
            </p>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-ivory/55 sm:text-base">
              The journey into the wilderness is not a transfer to be endured. It is the
              beginning of the stay itself.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="group relative overflow-hidden">
          <img
            data-testid="discovery-image"
            src={IMG.golGhar}
            alt="The Gol Ghar at The Jamoon, lit by lamplight and fire after dark"
            loading="lazy"
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 lg:aspect-[5/6]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent" />
          <p className="absolute bottom-5 left-5 text-[11px] tracking-[0.25em] text-ivory/80">
            THE GOL GHAR · AFTER DARK
          </p>
        </Reveal>
      </div>
    </section>
  );
}
